//frontend/src/dropdownMap/1BAct6_dropdownFieldMapping.js

export const dropdownFieldsByIdx = {
    9: "SubActivity",
    10: "CBOEstablish",
    11: "ConductedBy",
    15: "Gender",
    17: "PovertyLevel",
    18: "PWDStatus",
    19: "PositionInGroup",
    20: "MSME",
    26: "ACRegistered",
    27: "GrantReceived",
};

export const dropdownOptions = {
    //internal values should match database stored values
    //LA and EN values are for display purpose

    SubActivity: {
        internal: [
            "subact1", "subact2", "subact3", "subact4", "subact5", "subact6",
            "subact7", "subact8", "subact9", "subact10", "subact11", "subact12",
            "subact13", "subact14", "subact15", "subact16", "subact17", "subact18",
            "subact19", "subact20", "subact21"
        ],
        LA: {
            "subact1": "ກຸ່ມລ້ຽງແບ້",
            "subact2": "ກຸ່ມລ້ຽງໝູ",
            "subact3": "ກຸ່ມລ້ຽງສັດປິກ",
            "subact4": "ກຸ່ມລ້ຽງປາ",
            "subact5": "ກຸ່ມລ້ຽງກົບ",
            "subact6": "ກຸ່ມລ້ຽງເຜີ່ງ",
            "subact7": "ກຸ່ມປຸກຜັກເຮືອນຮົມ",
            "subact8": "ກຸ່ມປຸກຜັກ",
            "subact9": "ກຸ່ມປູກຜັກທຽມ",
            "subact10": "ກຸ່ມປຸກເຂົ້າ",
            "subact11": "ກຸ່ມປູກຖົ່ວຍາວ",
            "subact12": "ກຸ່ມປູກເຫັດ",
            "subact13": "ກຸ່ມປູກ​ຫມາກ​ຂ່າ",
            "subact14": "ກຸ່ມປູກຫຍ້າລ້ຽງສັດ",
            "subact15": "ກຸ່ມປຸກໄມ້ໃຫ້ຫມາກ",
            "subact16": "ກຸ່ມປູກ​ໝາກ​ແຫນ່ງ",
            "subact17": "ກຸ່ມຜະລິດຊາ",
            "subact18": "ກຸ່ມປຸກກາເຟ",
            "subact19": "ກຸ່ມ ປູກແຂມ",
            "subact20": "ກຸ່ມປຸກໃຜ່",
            "subact21": "ກຸ່ມປຸກກ້ວຍ"
        },
        EN: {
            "subact1": "Goat raising",
            "subact2": "Pig raising",
            "subact3": "Poultry raising",
            "subact4": "Fish raising",
            "subact5": "Frog raising",
            "subact6": "Bee Keeping",
            "subact7": "Vegetable in greenhouse",
            "subact8": "Vegetable growing",
            "subact9": "Garlic growing",
            "subact10": "Rice growing",
            "subact11": "Long been growing",
            "subact12": "Mushroom",
            "subact13": "Galangal",
            "subact14": "Forage plantation",
            "subact15": "Horticulture",
            "subact16": "Cardamom",
            "subact17": "Tea production",
            "subact18": "Coffee production",
            "subact19": "Broom grass plantation",
            "subact20": "Bamboo",
            "subact21": "Banana"
        }
    },
    CBOEstablish: {
        internal: ["1", "2"],
        LA: { "1": "ສ້າງໃໝ່", "2": "ປັບປຸງຄືນ" },
        EN: { "1": "New", "2": "Renovated" }
    },
    ConductedBy: {
        internal: ["dafo", "gst", "maf", "npco", "pafo", "wfp"],
        LA: {
            "dafo": "ຫ້ອງການ ກປ  ເມືອງ",
            "gst": "ທີມງານຊ່ວຍເຫຼືອກຸ່ມ",
            "maf": "ກະຊວງ ກປ",
            "npco": "ຫ້ອງການປະສານງານສູນກາງ",
            "pafo": "ພະແນກ ກປ ແຂວງ",
            "wfp": "ອົງການອາຫານໂລກ"
        },
        EN: {
            "dafo": "DAFO",
            "gst": "GST",
            "maf": "MAF",
            "npco": "NPCO",
            "pafo": "PAFO",
            "wfp": "WFP"
        }
    },
    Gender: {
        internal: ["Male", "Female"],
        LA: { "Male": "ຊາຍ", "Female": "ຍິງ" },
        EN: { "Male": "Male", "Female": "Female" }
    },
    PovertyLevel: {
        internal: ["p", "np"],
        LA: { "p": "P", "np": "NP" },
        EN: { "p": "P", "np": "NP" }
    },
    PWDStatus: {
        internal: ["no", "yes"],
        LA: { "no": "No", "yes": "Yes" },
        EN: { "no": "No", "yes": "Yes" }
    },
    PositionInGroup: {
        internal: ["g_head", "g_deputy", "g_member"],
        LA: { "g_head": "ຫົວໜ້າກຸ່ມ", "g_deputy": "ຮອງຫົວໜ້າກຸ່ມ", "g_member": "ສະມາຊິກກຸ່ມ"  },
        EN: { "g_head": "Group head", "g_deputy": "Deputy group head" , "g_member": "Group member" }
    },
    MSME: {
        internal: ["no", "yes"],
        LA: { "no": "No", "yes": "Yes" },
        EN: { "no": "No", "yes": "Yes" }
    },
    ACRegistered: {
        internal: ["ac_no", "ac_yes"],
        LA: { "ac_no": "No", "ac_yes": "Yes" },
        EN: { "ac_no": "No", "ac_yes": "Yes" }
    },
    GrantReceived: {
        internal: ["grant_no", "grant_yes"],
        LA: { "grant_no": "No", "grant_yes": "Yes" },
        EN: { "grant_no": "No", "grant_yes": "Yes" }
    }
};

// Reverse mapping: LA → _male etc.
// export const dropdownReverseMap = {};
// Object.keys(dropdownOptions).forEach(field => {
//     dropdownReverseMap[field] = { LA: {}, EN: {} };
//     const opts = dropdownOptions[field];
//     opts.internal.forEach(intVal => {
//         dropdownReverseMap[field].LA[opts.LA[intVal]] = intVal;
//         dropdownReverseMap[field].EN[opts.EN[intVal]] = intVal;
//     });
// });
export const dropdownReverseMap = {};
Object.keys(dropdownOptions).forEach(field => {
    dropdownReverseMap[field] = { LA: {}, EN: {} };
    const opts = dropdownOptions[field];
    opts.internal.forEach(intVal => {
        const strVal = String(intVal); // force string
        dropdownReverseMap[field].LA[opts.LA[strVal]] = strVal;
        dropdownReverseMap[field].EN[opts.EN[strVal]] = strVal;
    });
});
